import {skipToken} from '@apollo/client';

import {useSourceDataUploadHistorySuspenseQuery} from 'api/sourceDataUploads/sourceDataUploadHistory.generated';
import {decisionsGraphQLClient} from 'modules/decisionsNext/api';
import {useEntityAccess} from 'core/hooks/useEntityAccess';

export const useIsSourceDataExists = () => {
  const {withDataManagementOnly} = useEntityAccess();

  const {data} = useSourceDataUploadHistorySuspenseQuery(
    withDataManagementOnly
      ? {
          client: decisionsGraphQLClient,
        }
      : skipToken
  );

  return {
    isSourceDataExists: withDataManagementOnly ? !!data?.sourceDataUploads.history.length : true,
  };
};
